<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<!-- eslint-disable-next-line @angular-eslint/template/mouse-events-have-key-events -->
<div class="row">
  <!-- eslint-disable-next-line @angular-eslint/template/mouse-events-have-key-events -->
  <div class="col-12">
    @if (toggleRunningWorkflow) {
      <div
        [@displayAnimatedMessage]="toggleRunningWorkflow"
        [ngClass]="{ sticky: isSticky }"
        class="running-workflow-alert xrx-alert-box alert-success"
        role="alert">
        <div class="alert-content">
          <div class="d-flex flex-row mb-2">
            <span class="xgl-checkmark xglsize-32"></span>
            <span
              class="running-label"
              [xdaTranslate]="'SDE_RUNNING_WORKFLOW'"></span>
            <button
              class="modal-close-btn"
              (click)="toggleRunningWorkflow = false">
              <span aria-hidden="true" class="xgl-close"></span>
            </button>
          </div>
          <span class="alert-text">{{ runningWorkflowName }}</span>
        </div>
      </div>
    }
    <!-- eslint-disable-next-line @angular-eslint/template/mouse-events-have-key-events -->
    <div
      class="workflow-toolbar"
      role="region"
      [attr.aria-label]="'SDE_WORKFLOWS' | xdaTranslate">
      <h4 class="h4 align-self-center flex-grow-1 workflow-type-label m-0">
        {{ activeTab | xdaTranslate }}
      </h4>
      <!-- eslint-disable-next-line @angular-eslint/template/mouse-events-have-key-events -->
      <div class="workflow-button-wrapper">
        <!-- eslint-disable-next-line @angular-eslint/template/mouse-events-have-key-events -->
        <div
          ngbNav
          #workflows="ngbNav"
          [animation]="false"
          [(activeId)]="activeTab"
          class="workflow-nav-wrapper"
          role="tablist"
          aria-label="..."
          (navChange)="navChanged($event)">
          <ng-container ngbNavItem="SDE_SINGLE_WORKFLOWS">
            @if (!isGuest) {
              <a
                ngbNavLink
                class="workflow-nav-link xrx-btn btn-secondary xgl-workflow_single"
                [ngbTooltip]="'SDE_SINGLE' | xdaTranslate"
                triggers="hover">
                <span class="btn-label" [xdaTranslate]="'SDE_SINGLE'"></span>
              </a>
            }
            <ng-template ngbNavContent>
              @if (singleWorkflows.length) {
                <div
                  class="single-workflows-container"
                  role="region"
                  [attr.aria-label]="'SDE_SINGLE_WORKFLOWS' | xdaTranslate">
                  <div class="row no-gutters workflow-wrapper">
                    @for (workflow of singleWorkflows; track workflow) {
                      <div
                        class="col-lg-3 col-sm-4 col-xs-6 col-xxs-12 p-1 d-flex align-items-start justify-content-center">
                        <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
                        <div class="workflow" (click)="openWorkflow(workflow)">
                          @if (workflow.icon.image) {
                            <img
                              class="workflow-image"
                              [src]="workflow.icon.image"
                              [alt]="'SDE_WORKFLOW_ICON' | xdaTranslate" />
                          } @else {
                            <div class="d-inline">
                              <div
                                class="workflow-image {{
                                  workflow.icon.glyph
                                }} {{
                                  workflow.icon.color
                                }} xglsize-64 text-center align-middle"></div>
                            </div>
                          }
                          <div
                            class="workflow-name"
                            [xdaTranslate]="workflow.name"></div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
              @if (singleWorkflows.length === 0 && !isLoadingWorkflows) {
                <div class="all-workflows-hidden-container">
                  <div class="align-items-center d-flex flex-column">
                    <i
                      class="workflow-hidden-glyph"
                      [ngClass]="
                        combinedWorkflows.length
                          ? 'xgl-workflow_single'
                          : 'xgl-view_disabled'
                      "></i>
                    <h4 class="h4">
                      {{
                        (combinedWorkflows.length
                          ? 'SDE_ALL_SINGLE_WORKFLOWS'
                          : 'SDE_ALL_WORKFLOWS_HAVE'
                        ) | xdaTranslate
                      }}
                    </h4>
                  </div>
                </div>
              }
            </ng-template>
          </ng-container>
          @if (isAdvancedPlan) {
            <ng-container ngbNavItem="SDE_COMBINATION_WORKFLOWS">
              @if (!isGuest) {
                <a
                  ngbNavLink
                  class="workflow-nav-link xrx-btn btn-secondary xgl-workflow_combo"
                  [ngbTooltip]="'COMBINATION' | xdaTranslate"
                  triggers="hover">
                  <span class="btn-label" [xdaTranslate]="'COMBINATION'"></span>
                </a>
              }
              <ng-template ngbNavContent>
                @if (combinedWorkflows.length && isAdvancedPlan) {
                  <div
                    class="combined-workflows-container"
                    role="region"
                    [attr.aria-label]="
                      'SDE_COMBINATION_WORKFLOWS' | xdaTranslate
                    ">
                    <div class="row no-gutters workflow-wrapper">
                      @for (workflow of combinedWorkflows; track workflow) {
                        <div
                          class="col-lg-3 col-sm-4 col-xs-6 col-xxs-12 p-1 d-flex align-items-start justify-content-center">
                          <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
                          <div
                            class="workflow"
                            (click)="openWorkflow(workflow)">
                            @if (workflow.icon.image) {
                              <img
                                class="workflow-image"
                                [src]="workflow.icon.image"
                                [alt]="'SDE_WORKFLOW_ICON' | xdaTranslate" />
                            } @else {
                              <div class="d-inline">
                                <div
                                  class="workflow-image {{
                                    workflow.icon.glyph
                                  }} {{
                                    workflow.icon.color
                                  }} xglsize-64 text-center align-middle"></div>
                              </div>
                            }
                            <div
                              class="workflow-name"
                              [xdaTranslate]="workflow.name"></div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
                @if (combinedWorkflows.length === 0 && !isLoadingWorkflows) {
                  <div class="all-workflows-hidden-container">
                    <div class="align-items-center d-flex flex-column">
                      <i
                        class="workflow-hidden-glyph"
                        [ngClass]="
                          singleWorkflows.length
                            ? 'xgl-workflow_combo'
                            : 'xgl-view_disabled'
                        "></i>
                      <h4 class="h4">
                        {{
                          (singleWorkflows.length
                            ? 'SDE_ALL_COMBINATION_WORKFLOWS'
                            : 'SDE_ALL_WORKFLOWS_HAVE'
                          ) | xdaTranslate
                        }}
                      </h4>
                    </div>
                  </div>
                }
              </ng-template>
            </ng-container>
          }
          <ng-container ngbNavItem="SDE_SAVED_WORKFLOWS">
            @if (!isGuest) {
              <a
                ngbNavLink
                class="workflow-nav-link xrx-btn btn-secondary xgl-save"
                [ngbTooltip]="'SDE_SAVED' | xdaTranslate"
                triggers="hover">
                <span class="btn-label" [xdaTranslate]="'SDE_SAVED'"></span>
              </a>
            }
            <ng-template ngbNavContent>
              @if (savedWorkflows.length > 0) {
                <div
                  class="saved-workflows-container"
                  role="region"
                  [attr.aria-label]="'SDE_SAVED_WORKFLOWS' | xdaTranslate">
                  @if (toggleDeleteWorkflow) {
                    <div
                      [@displayAnimatedMessage]="toggleDeleteWorkflow"
                      class="xrx-alert-box alert-warning mb-0"
                      role="alert">
                      <div
                        class="alert-content align-items-center d-flex flex-column">
                        <p
                          class="alert-text"
                          [xdaTranslate]="'SDE_SELECT_X_BUTTON'"></p>
                        <button
                          class="xrx-btn btn-warning-outline xgl-checkmark"
                          (click)="
                            toggleDeleteWorkflow = !toggleDeleteWorkflow
                          ">
                          <span
                            class="btn-label"
                            [xdaTranslate]="'SDE_DONE'"></span>
                        </button>
                      </div>
                    </div>
                  }
                  <div
                    class="row no-gutters workflow-wrapper"
                    [ngClass]="{
                      'delete-workflow-active': toggleDeleteWorkflow,
                    }">
                    @for (workflow of savedWorkflows; track workflow) {
                      <div
                        [ngClass]="{
                          'col-lg-3 col-sm-4 col-xs-6 col-xxs-12 p-1 saved-workflows d-flex align-items-start justify-content-center':
                            !workflow.isHidden,
                        }">
                        @if (!workflow.isHidden) {
                          <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
                          <div
                            class="workflow saved-workflow"
                            [ngbTooltip]="
                              'SDE_FEATURE_SAVED_WORKFLOW' | xdaTranslate
                            "
                            [disableTooltip]="!workflow.isDisabled"
                            triggers="click"
                            (click)="openWorkflow(workflow)">
                            <div class="workflow-image-wrapper">
                              <div
                                class="image-holder"
                                [ngClass]="{ disabled: workflow.isDisabled }">
                                @if (workflow.icon.image) {
                                  <img
                                    class="workflow-image saved-workflow-image"
                                    [src]="workflow.icon.image"
                                    [alt]="
                                      'SDE_WORKFLOW_ICON' | xdaTranslate
                                    " />
                                } @else {
                                  <div
                                    class="workflow-image saved-workflow-image {{
                                      workflow.icon.color
                                    }} text-center align-middle d-flex align-items-center justify-content-center">
                                    <div
                                      class="{{
                                        workflow.icon.glyph
                                      }} xglsize-64"></div>
                                  </div>
                                }
                              </div>
                              <div class="saved-workflow-buttons">
                                @if (
                                  toggleDeleteWorkflow && workflow.canBeDeleted
                                ) {
                                  <button
                                    [@deleteSavedWorkflowButton]="
                                      toggleDeleteWorkflow
                                    "
                                    type="button"
                                    class="xrx-btn btn-short fileinput-exists xgl-close saved-workflow-btn-delete"
                                    [attr.aria-label]="
                                      'SDE_DELETE' | xdaTranslate
                                    "
                                    (click)="
                                      deleteWorkflow($event, workflow)
                                    "></button>
                                }
                                @if (workflow.isShared) {
                                  <div
                                    class="shared-glyph d-flex align-items-center justify-content-center">
                                    <i
                                      class="xglsize-20"
                                      [ngClass]="
                                        workflow.canBeDeleted
                                          ? 'xgl-group_favorite'
                                          : 'xgl-group'
                                      "></i>
                                  </div>
                                }
                              </div>
                            </div>
                            <div
                              class="workflow-name saved-workflow-name"
                              [ngClass]="{ disabled: workflow.isDisabled }"
                              [xdaTranslate]="workflow.name"
                              [ngbTooltip]="workflow.name"></div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
              @if ((savedWorkflows.length === 0 || savedWorkflowsAllHidden()) && !isLoadingWorkflows) {
                <div class="all-workflows-hidden-container">
                  <div class="align-items-center d-flex flex-column">
                    <i class="workflow-hidden-glyph xgl-save"></i>
                    <h4 class="h4">
                      {{ 'SDE_NO_SAVED_WORKFLOWS' | xdaTranslate }}
                    </h4>
                  </div>
                </div>
              }
            </ng-template>
          </ng-container>
          @if (
            isAdvancedPlan &&
            !(isAutoWorkflowsDisabled && automatedWorkflows.length === 0)
          ) {
            <ng-container ngbNavItem="SDE_AUTOMATED_WORKFLOWS">
              @if (!isGuest) {
                <a
                  ngbNavLink
                  class="workflow-nav-link xrx-btn btn-secondary xgl-auto"
                  [ngbTooltip]="'AUTOMATED' | xdaTranslate"
                  triggers="hover">
                  <span class="btn-label" [xdaTranslate]="'AUTOMATED'"></span>
                </a>
              }
              <ng-template ngbNavContent>
                @if (automatedWorkflows.length) {
                  <!-- eslint-disable-next-line @angular-eslint/template/mouse-events-have-key-events -->
                  <div
                    class="automated-workflows-container"
                    role="region"
                    [attr.aria-label]="
                      'SDE_AUTOMATED_WORKFLOWS' | xdaTranslate
                    ">
                    <div class="row">
                      <div class="col-xs-12 col-sm-5 col-md-4 col-lg-5">
                        <div class="search-wrapper">
                          <div
                            class="input-group search-group"
                            [ngClass]="{
                              'input-group-is-invalid': !searchIsValid,
                            }">
                            <input
                              id="workflowSearch"
                              [(ngModel)]="searchTerm"
                              type="text"
                              class="form-control search-term"
                              (keyup)="validateSearch($event)"
                              (blur)="validateSearch($event)"
                              [placeholder]="searchPlaceholder"
                              [minlength]="searchMinLength" />
                            @if (showClearSearch) {
                              <div class="input-group-append">
                                <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
                                <button
                                  type="button"
                                  class="xrx-btn btn-short btn-primary xgl-clear_all"
                                  [ngbTooltip]="clearTooltip"
                                  (click)="clearSearch()"></button>
                              </div>
                            }
                          </div>
                          <div
                            class="invalid-feedback"
                            [ngClass]="{ 'd-block': !searchIsValid }"
                            [xdaTranslate]="'SDE_ENTERT_LEAST_2'"
                            [formatValues]="searchMinLength"></div>
                        </div>
                      </div>
                      <div class="action-buttons col-sm-7 col-md-8 col-lg-7">
                        <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
                        <button
                          type="button"
                          class="xrx-btn btn-primary"
                          (click)="addAutoWorkflow()"
                          [xdaTranslate]="'SDE_CREATE'"
                          [disabled]="isAutoWorkflowsDisabled"></button>
                      </div>
                    </div>
                    <!-- eslint-disable-next-line @angular-eslint/template/mouse-events-have-key-events -->
                    <table class="table table-responsive table-sort mb-0">
                      <thead>
                        <tr>
                          <th
                            sortableCol="wfName"
                            direction="asc"
                            [initialSort]="true"
                            (sort)="setSortParams($event)"
                            scope="col"
                            colspan="2">
                            <span xdaTranslate>SDE_NAME3</span>
                          </th>
                          <th
                            sortableCol="jobs"
                            direction="asc"
                            (sort)="setSortParams($event)"
                            sorttype="number"
                            scope="col">
                            <span xdaTranslate>SDE_JOBS</span>
                          </th>
                          <th scope="col" [xdaTranslate]="'SDE_STATUS'"></th>
                          <th
                            sortableCol="enabled"
                            direction="asc"
                            (sort)="setSortParams($event)"
                            sorttype="number"
                            scope="col">
                            <span xdaTranslate>SDE_ACTIVE</span>
                          </th>
                          <th scope="col"></th>
                        </tr>
                      </thead>
                      <!-- eslint-disable-next-line @angular-eslint/template/mouse-events-have-key-events -->
                      <tbody>
                        @for (
                          workflow of automatedWorkflows
                            | tableFilter
                              : searchTerm
                              : ['wfName']
                              : searchMinLength
                              : tableFilterMetadata
                            | tableSort: direction : column : type
                            | slice: (page - 1) * pageSize : page * pageSize;
                          track workflow;
                          let i = $index;
                          let last = $last;
                          let first = $first
                        ) {
                          <!-- eslint-disable-next-line @angular-eslint/template/mouse-events-have-key-events -->
                          <tr
                            triggers="hover click"
                            #workflowTooltip="ngbTooltip"
                            [ngbTooltip]="
                              (isAutoWorkflowsDisabled
                                ? 'SDE_ADMINISTRATOR_DISABLED_AUTOMATED'
                                : 'SDE_ADMINISTRATOR_DISABLED_ONE'
                              ) | xdaTranslate
                            "
                            [disableTooltip]="!$any(workflow).isDisabled"
                            (click)="
                              $any(workflow).isDisabled &&
                                openWorkflowTooltip(i)
                            "
                            (mouseover)="
                              $any(workflow).isDisabled &&
                                closeWorkflowTooltip($event, i)
                            ">
                            <td
                              class="wf-image"
                              [ngClass]="{
                                disabled: $any(workflow).isDisabled,
                              }">
                              @if ($any(workflow).icon.image) {
                                <img
                                  class="workflow-image"
                                  [src]="$any(workflow).icon.image"
                                  [alt]="'SDE_WORKFLOW_ICON' | xdaTranslate" />
                              } @else {
                                <div
                                  class="workflow-image {{
                                    $any(workflow).icon.glyph
                                  }} {{
                                    $any(workflow).icon.color
                                  }} xglsize-32 text-center align-middle"></div>
                              }
                            </td>
                            <td [attr.aria-label]="$any(workflow).name">
                              <span
                                id="{{ $any(workflow).id }}"
                                [ngClass]="{
                                  disabled: $any(workflow).isDisabled,
                                }"
                                triggers="hover"
                                [ngbTooltip]="$any(workflow).name"
                                [disableTooltip]="
                                  !isOverflowActive($any(workflow).id) ||
                                  $any(workflow).isDisabled
                                "
                                >{{ $any(workflow).name }}</span
                              >
                            </td>
                            <td
                              [ngClass]="{
                                disabled: $any(workflow).isDisabled,
                              }">
                              {{ $any(workflow).jobs }}
                            </td>
                            <td
                              class="wf-status"
                              [ngClass]="{
                                disabled: $any(workflow).isDisabled,
                              }">
                              <div class="wf-status-wrapper">
                                <div>
                                  <span [xdaTranslate]="'SDE_COMPLETED'"></span>
                                  <span>: </span>
                                  <span>{{
                                    $any(workflow).jobStatus.completed
                                  }}</span>
                                </div>
                                <div>
                                  <span [xdaTranslate]="'SDE_FAILED1'"></span>
                                  <span>: </span>
                                  <span>{{
                                    $any(workflow).jobStatus.failed
                                  }}</span>
                                </div>
                              </div>
                            </td>
                            <td
                              [ngClass]="{
                                disabled: $any(workflow).isDisabled,
                              }">
                              <xrx-toggle-switch
                                (toggle)="onToggleAutoWorkflow($any(workflow))"
                                [isMfd]="false"
                                [switchOn]="$any(workflow).enabled"
                                [disabled]="$any(workflow).isDisabled">
                              </xrx-toggle-switch>
                            </td>
                            <td>
                              <div class="icons d-flex justify-content-end">
                                <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
                                <span
                                  class="wf-action-icon wf-icon-run-now xgl-video_player xglsize-24"
                                  (click)="
                                    !$any(workflow).isDisabled &&
                                      $any(workflow).enabled &&
                                      !toggleRunningWorkflow &&
                                      runNow($event, $any(workflow))
                                  "
                                  placement="left"
                                  triggers="hover"
                                  [ngbTooltip]="
                                    'SDE_RUN_WORKFLOW_NOW' | xdaTranslate
                                  "
                                  [ngClass]="{
                                    disabled:
                                      $any(workflow).isDisabled ||
                                      !$any(workflow).enabled ||
                                      toggleRunningWorkflow,
                                  }"
                                  [disableTooltip]="
                                    $any(workflow).isDisabled ||
                                    !$any(workflow).enabled ||
                                    toggleRunningWorkflow
                                  "
                                  >></span
                                >
                                <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
                                <span
                                  class="wf-action-icon wf-icon-history xgl-queue xglsize-24"
                                  (click)="
                                    viewAutoWorkflowHistory(
                                      $event,
                                      $any(workflow)
                                    )
                                  "
                                  placement="left"
                                  triggers="hover"
                                  [ngbTooltip]="
                                    'SDE_VIEW_JOB_HISTORY' | xdaTranslate
                                  "></span>
                                <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
                                <span
                                  class="wf-action-icon wf-icon-edit xgl-edit xglsize-24"
                                  (click)="
                                    !$any(workflow).isDisabled &&
                                      editAutoWorkflow($any(workflow))
                                  "
                                  placement="left"
                                  triggers="hover"
                                  [ngbTooltip]="
                                    'SDE_EDIT_WORKFLOW1' | xdaTranslate
                                  "
                                  [ngClass]="{
                                    disabled: $any(workflow).isDisabled,
                                  }"
                                  [disableTooltip]="
                                    $any(workflow).isDisabled
                                  "></span>
                                <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
                                <span
                                  class="wf-action-icon wf-icon-delete xgl-trash xglsize-24"
                                  (click)="
                                    deleteAutoWorkflow($event, $any(workflow))
                                  "
                                  placement="left"
                                  triggers="hover"
                                  [ngbTooltip]="
                                    'SDE_DELETE_WORKFLOW1' | xdaTranslate
                                  "></span>
                              </div>
                            </td>
                          </tr>
                        }
                        <tr class="no-results">
                          <td
                            class="text-center"
                            colspan="6"
                            [xdaTranslate]="'SDE_NO_SEARCH_RESULTS2'"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                }
                @if (
                  automatedWorkflows &&
                  automatedWorkflows.length &&
                  displayPagination
                ) {
                  <xrx-pagination
                    [(page)]="page"
                    [(pageSize)]="pageSize"
                    [initialPageSize]="initialPageSize"
                    [pageSizeList]="pageSizeList"
                    [collectionSize]="tableFilterMetadata.count"
                    class="d-flex justify-content-center justify-content-sm-end">
                  </xrx-pagination>
                }
                @if (automatedWorkflows.length === 0 && !isLoadingAutoWorkflows) {
                  <div
                    class="all-workflows-hidden-container automated-workflows">
                    <div class="align-items-center d-flex flex-column">
                      <i class="workflow-hidden-glyph xgl-auto"></i>
                      <h4 class="h4">
                        {{ 'SDE_HAVE_EVERYDAY_DOCUMENT1' | xdaTranslate }}
                      </h4>
                      <br />
                      <div>
                        <span [xdaTranslate]="'SDE_SET_UP_AUTOMATED'"></span>
                      </div>
                      <div>
                        <span
                          [xdaTranslate]="'SDE_SELECT_CREATE_AUTOMATED'"></span>
                      </div>
                      <br />
                      <button
                        class="xrx-btn btn-primary"
                        (click)="addAutoWorkflow()">
                        {{ 'SDE_CREATE_AUTOMATED_WORKFLOW' | xdaTranslate }}
                      </button>
                    </div>
                  </div>
                }
              </ng-template>
            </ng-container>
          }
        </div>
        @if (!configureEnabled && savedWorkflows.length > 0 && canBeDeleted) {
          <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
          <button
            class="xrx-btn btn-secondary btn-short xgl-trash workflow-btn-delete"
            (click)="
              toggleDeleteWorkflow = true; activeTab = 'SDE_SAVED_WORKFLOWS'
            "
            [ngbTooltip]="'SDE_DELETE_SAVED_WORKFLOWS' | xdaTranslate"
            triggers="hover"></button>
        }
        @if (configureEnabled) {
          <div class="configure-services-features-container">
            <div
              #configDropdown
              class="dropdown nowrap-tooltip"
              [ngClass]="{ show: configIsExpanded }">
              <button
                class="xrx-btn btn-secondary btn-short xgl-toggles configure-services-features-btn-open"
                type="button"
                data-dropdown="center"
                data-toggle="dropdown"
                data-dropup="window"
                aria-haspopup="true"
                aria-expanded="false"
                [ngbTooltip]="
                  (configureEnabled &&
                  this.savedWorkflows.length > 0 &&
                  this.canBeDeleted
                    ? 'SDE_WORKFLOW_SETTINGS'
                    : 'SDE_CONFIGURE_WORKFLOWS_FEATURES'
                  ) | xdaTranslate
                "
                [attr.aria-label]="
                  (configureEnabled &&
                  this.savedWorkflows.length > 0 &&
                  this.canBeDeleted
                    ? 'SDE_WORKFLOW_SETTINGS'
                    : 'SDE_CONFIGURE_WORKFLOWS_FEATURES'
                  ) | xdaTranslate
                "
                triggers="hover"
                (click)="openConfigOrToggle()"></button>
              <span class="dropdown-arrow"></span>
              <div class="dropdown-menu" [ngClass]="{ show: configIsExpanded }">
                <a
                  class="dropdown-item"
                  href="#"
                  (click)="openConfigurationModal(); configIsExpanded = false"
                  ><i class="xgl-gear"></i>
                  <span
                    [xdaTranslate]="'SDE_CONFIGURE_WORKFLOWS_FEATURES'"></span
                ></a>
                <div class="dropdown-divider m-0"></div>
                <a
                  class="dropdown-item"
                  href="#"
                  (click)="
                    toggleDeleteWorkflow = true;
                    configIsExpanded = false;
                    activeTab = 'SDE_SAVED_WORKFLOWS'
                  "
                  ><i class="xgl-trash"></i
                  ><span [xdaTranslate]="'SDE_DELETE_SAVED_WORKFLOWS'"></span
                ></a>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
<div [ngbNavOutlet]="workflows" class="workflow-tab-content"></div>
